
setTimeout(() => {
  const searchInput = document.querySelector('#HeaderWrapper .site-nav__icons .js-search-header');
  if (searchInput) {
    searchInput.addEventListener('click', (e) => {
      e.preventDefault();
      const searchItems = document.querySelectorAll('.ui-menu-item');
    });
  }
}, 2000);

const variants = document.querySelectorAll('[js-variant-label]');
variants.forEach(variant => {
  const dataValue = variant.getAttribute('data-value');
  const values = dataValue.split('(');

  let preLabel = '', afterLabel = '';
  values.forEach(value => {
    if (parseFloat(value) != NaN && value.includes('Count')) {
      afterLabel = value.split(')')[0];
    } else {
      if (value.includes(')')) {
        value = `(${value}`;
      }
      preLabel += value;
    }
  });

  const html = `
    <b>${preLabel}</b><br><small>${afterLabel}</small>
  `;

  variant.innerHTML = html;
});

function isNumeric(str) {
  const pattern = /^-?\d+(\.\d+)?$/;
  return pattern.test(str);
}

let rcContainer = undefined;

document.addEventListener("DOMContentLoaded", (event) => {
  function showSlidePriceToButtonByQty(count, el) {
    el.querySelector('.js-qty__num').value = count;
    const addButtonText = el.parentElement.querySelector('[data-add-to-cart] [data-add-to-cart-text]');
    if(!addButtonText)
      return;

    let rslt = '';
    const price = addButtonText.dataset.variantPrice;
    rslt = (price / 100).toString();

    if (rslt != '') {
      const defaultText = addButtonText.getAttribute('data-default-text');

      addButtonText.innerHTML = `${defaultText} - $${(myGeeks(rslt) * count).toFixed(2)}`;
    }
  }
  
  function showPriceToButtonByQty(count) {

    const addButtonText = document.querySelector('.product-single__meta [data-add-to-cart] [data-add-to-cart-text]');
    if(!addButtonText)
      return;

    let rslt = '';
    if(rcContainer) {
      const oneTime = rcContainer.querySelector('.rc-option__onetime input');
      const subScribe = rcContainer.querySelector('.rc-option__subsave input');

      const oneTimePrice = rcContainer.querySelector('.rc_widget__price--onetime');
      const saveScribePrice = rcContainer.querySelector('.rc_widget__price--subsave');

      if (oneTime.checked) {
        rslt = oneTimePrice.innerHTML;
      } else if (subScribe.checked){
        rslt = saveScribePrice.innerHTML;
      }
    } else {
      const price = addButtonText.dataset.variantPrice;
      rslt = (price / 100).toString();
    }

    if (rslt != '') {
      const defaultText = addButtonText.getAttribute('data-default-text');

      addButtonText.innerHTML = `${defaultText} - $${(myGeeks(rslt) * count).toFixed(2)}`;
    }
  }

  function myGeeks(str) {
    // Using match with regEx
    let matches = str.match(/(\d+)/);

    // Display output if number extracted
    if (matches) {
      return matches[0];
    } else {
      return 0;
    }
  }

  const quantitySlideSelectors = document.querySelectorAll('.related_products .js-qty__wrapper');
  quantitySlideSelectors.forEach((quantitySlideSelector) => {
    const plus = quantitySlideSelector.querySelector('.js-qty__adjust--plus');
    const minus = quantitySlideSelector.querySelector('.js-qty__adjust--minus');
    const quantityInput = quantitySlideSelector.querySelector('.js-qty__num');
    if (plus && !plus.hasEventListener) {
      plus.addEventListener('click', (e) => {
        if (quantityInput) {
          var quantity = parseInt(quantityInput.value);
          showSlidePriceToButtonByQty(quantity+1, quantitySlideSelector);
        }
      });
      plus.hasEventListener = true; // mark as having an event listen
    }

    if (minus && !minus.hasEventListener) {
      minus.addEventListener('click', (e) => {
        if (quantityInput) {
          var quantity = parseInt(quantityInput.value);
          showSlidePriceToButtonByQty(quantity>1 ? quantity-1 : 1, quantitySlideSelector);
        }
      });
      minus.hasEventListener = true; // mark as having an event listen
    }

    const fieldset = document.querySelector('.variant-input-wrap');
    if (fieldset) {
      fieldset.addEventListener('change', (e) => {
        if (e.target && e.target.matches('input[type="radio"]')) {
          showSlidePriceToButtonByQty(quantityInput.value, quantitySlideSelector);
        }
      });
    }
  });
  
  const quantitySelector = document.querySelector('.product-single__meta .js-qty__wrapper');
  if (quantitySelector) {
    const plus = document.querySelector('.js-qty__wrapper .js-qty__adjust--plus');
    const minus = document.querySelector('.js-qty__wrapper .js-qty__adjust--minus');
    const quantityInput = document.querySelector('.js-qty__wrapper .js-qty__num');

    if (plus && !plus.hasEventListener) {
      plus.addEventListener('click', (e) => {
        if (quantityInput) {
          showPriceToButtonByQty(quantityInput.value);
        }
      });
      plus.hasEventListener = true; // mark as having an event listen
    }

    if (minus && !minus.hasEventListener) {
      minus.addEventListener('click', (e) => {
        if (quantityInput) {
          showPriceToButtonByQty(quantityInput.value);
        }
      });
      minus.hasEventListener = true; // mark as having an event listen
    }

    const fieldset = document.querySelector('.variant-input-wrap');
    if (fieldset) {
      fieldset.addEventListener('change', (e) => {
        if (e.target && e.target.matches('input[type="radio"]')) {
          showPriceToButtonByQty(quantityInput.value);
        }
      });
    }
  }

  var timer = setInterval(() => {
    rcContainer = document.querySelector('.rc-container-wrapper');
    const purchaseContainer = document.querySelector('.purchase-subscribe');

    if (rcContainer) {
      clearInterval(timer);
      const frequencySelect = document.querySelector('.rc-selling-plans.rc_widget__option__plans select');
      const frequencyElement = document.querySelector('[js-frequency-select]');
      const paymentTerms = document.querySelector('.shopify-payment-terms');
      const oneTimeContainer = rcContainer.querySelector('.rc-option__onetime');

      const quantityInput = document.querySelector('.js-qty__wrapper .js-qty__num');

      showPriceToButtonByQty(quantityInput.value);

      if (oneTimeContainer.classList.contains('rc-option--active')) {
        oneTimeContainer.append(paymentTerms);
        paymentTerms.classList.add('active');
      }

      if (frequencySelect) {
        var cloneFrequencySelect = frequencySelect.cloneNode(true);
        frequencyElement.innerHTML = cloneFrequencySelect.innerHTML;

        frequencyElement.addEventListener('change', (e) => {
          e.preventDefault();

          frequencySelect.value = e.target.value;
        });
      } else {
        frequencyElement.classList.remove('active');
      }

      purchaseContainer.classList.add('active');

      // const buttons = document.querySelectorAll('.btn-purchase');
      const variants = document.querySelectorAll('.variant-input-wrap .variant-input');
      const oneTimeBtn = rcContainer.querySelector('.rc-option__onetime');
      const saveSubscribeBtn = rcContainer.querySelector('.rc-option__subsave');

      if (oneTimeBtn) {
        oneTimeBtn.addEventListener('click', (e) => {
          setTimeout(() => {
            showPriceToButtonByQty(quantityInput.value);
          }, 200);
        });
      }

      if (saveSubscribeBtn) {
        saveSubscribeBtn.addEventListener('click', (e) => {
          setTimeout(() => {
            showPriceToButtonByQty(quantityInput.value);
          }, 200);
        });
      }

      variants.forEach(variant => {
        variant.addEventListener('click', (e) => {
          setTimeout(() => {
            showPriceToButtonByQty(quantityInput.value);
          }, 200);
        });
      });

    }
  }, 1000);

  var timer1 = setInterval(() => {
    const addToCartBtn = document.querySelector('.isp_quick_view_add_to_cart_btn_quick_view');
    if (addToCartBtn) {
      clearInterval(timer1);
      addToCartBtn.addEventListener('click', (e) => {
        setTimeout(() => {
          location.reload();
        }, 1000);
      });
    }
  }, 1000);

  setTimeout(() => {
    clearInterval(timer);
    clearInterval(timer1);
  }, 1000000);
});
